export const DOCUMENTS_MONITORING_POLLING_DELAY = 1000;
